/*       */

import { gql } from '@apollo/client';

export default gql`
    query classificationsLeftPanelChildCountQuery($filterBy: [JSON]) {
        count: count(dataType: "class", filterBy: $filterBy)
    }
`;
